/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Тип авторов. \n\r\n1 - Исполнитель \n\r\n2 - Подкастер \n\r\n3 - Проповедник \n\r\n4 - Чтец \n<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Artist</b>: Исполнитель.</li>\n<li><b>2 - Podcaster</b>: Подкастер.</li>\n<li><b>3 - Preacher</b>: Проповедник.</li>\n<li><b>4 - Reader</b>: Чтец.</li>\n</ul>\n
 */
export const authorTypeEnumSchema = z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]).describe("Тип авторов. \n\r\n1 - Исполнитель \n\r\n2 - Подкастер \n\r\n3 - Проповедник \n\r\n4 - Чтец \n<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Artist</b>: Исполнитель.</li>\n<li><b>2 - Podcaster</b>: Подкастер.</li>\n<li><b>3 - Preacher</b>: Проповедник.</li>\n<li><b>4 - Reader</b>: Чтец.</li>\n</ul>\n")